import {
	Haptics,
	ImpactStyle,
	NotificationType,
} from '@capacitor/haptics';

// plugin's methods
const methods = [
	'impact',
	'notification',
	'vibrate',
	'selectionStart',
	'selectionChanged',
	'selectionEnd',
	'getResizeMode',
];

export function useNativeHaptics () {
	// methods
	const api = methods.reduce((api, name) => {
		api[name] = Haptics[name];
		return api;
	}, {});

	return {
		...api,
	};
}

export const HapticsImpactStyle = ImpactStyle;
export const HapticsNotificationType = NotificationType;
